// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as StopComponent} from './Stop.svg';

import Icon, { TIconProps } from '../Icon';

export const IconStop = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <StopComponent/>
  </Icon>
));
